import { makeStyles } from "@material-ui/styles";
import { CELL_HEIGHTS, TIMELINE_MONTH_HEADER_HEIGHT } from "@utils";

export default makeStyles(() => ({
  root: {
    position: "absolute",
    inset: 0,
    pointerEvents: "none",
    overflow: "visible",
    paddingTop: TIMELINE_MONTH_HEADER_HEIGHT,
  },
  titleSpacer: {
    height: CELL_HEIGHTS.LARGE,
  },
}));
